import { formatPayloadDate } from 'utils/helpers'

export const toAssignmentPutPayload = (values, assignment) => ({
  ...assignment,
  jobTitle: values.jobTitle,
  ...((values.endDate || assignment.endDate) && { endDate: formatPayloadDate(values.endDate) }),
  email: values.email,
  adAccount: values.adAccount,
  googleAccount: values.googleAccount,
  ldapAccount: values.ldapAccount,
  status: { id: values.status?.value },
  ...(values.store && { stores: values.store.map(s => ({ id: s.value })) }),
  ...(values.updateComment && { updateComment: values.updateComment }),
  details: values.details
})
